import {createContext, Dispatch, FC, ReactNode, useContext, useReducer} from "react";
import AssignmentViewReducer, {AssignmentViewState, AssignmentViewActions} from "./AssignmentViewReducer";
import {SearchableSortDirection} from "../generated/graphql";
import {ManifestFilterState} from "../components/manifest/list/components/manifest-filter/ManifestFilterState";

const InitialAssignmentViewState: AssignmentViewState = {
  manifestSort: {
    property: "driver.name.keyword",
    sortDirection: SearchableSortDirection.Asc
  },
  manifestFilters: new ManifestFilterState(),
  manifestQuery: undefined,
  dragAndDropTargets: [],
  currentDragAndDropTargets: [],
  showingJobIds: [],
  totalJobIds: 0,
  unassignedJobsPage: 1,
  assignmentTotalJobsNumbers: [],
  totalJobsNumberAndJobsIdOnPages: [],
  sortByColor: {
    enable: false,
    direction: SearchableSortDirection.Asc
  }
};

export const AssignmentViewStateContext = createContext<AssignmentViewState | undefined>(undefined);
export const AssignmentViewDispatchContext = createContext<Dispatch<AssignmentViewActions> | undefined>(undefined);

export const AssignmentViewProvider: FC<{children: ReactNode}> = ({children}) => {
  const [assignmentViewState, assignmentViewStateDispatch] = useReducer(
    AssignmentViewReducer,
    InitialAssignmentViewState
  );

  return (
    <AssignmentViewStateContext.Provider value={assignmentViewState}>
      <AssignmentViewDispatchContext.Provider value={assignmentViewStateDispatch}>
        {children}
      </AssignmentViewDispatchContext.Provider>
    </AssignmentViewStateContext.Provider>
  );
};

export const useAssignmentViewState = () => {
  const context = useContext(AssignmentViewStateContext);
  if (!context) {
    throw new Error("useAssignmentViewState must be used within an AssignmentViewProvider");
  }
  return context;
};

export const useAssignmentViewDispatch = () => {
  const context = useContext(AssignmentViewDispatchContext);
  if (!context) {
    throw new Error("useAssignmentViewDispatch must be used within an AssignmentViewProvider");
  }
  return context;
};
